<template>
  <TabTemplate class="fill-height">
    <template v-slot:chart>
      <SoilCompositionLineChart chartRef="soil-block"
      ></SoilCompositionLineChart>
    </template>
    <template v-slot:content>
      <SoilProfileBlockPanels
      ></SoilProfileBlockPanels>
    </template>
  </TabTemplate>
</template>
<script>
import SoilProfileBlockPanels from '@/components/soilcomposition/SoilProfileBlockPanels.vue';
import SoilCompositionLineChart from '@/components/soilcomposition/SoilCompositionLineChart.vue';
import TabTemplate from "@/components/common/TabTemplate.vue";

export default {
  name: "SoilProfileBlocksTab",
  components: {
    TabTemplate,
    SoilProfileBlockPanels,
    SoilCompositionLineChart,
  },
};
</script>
